/* eslint-disable max-len, indent, sonarjs/no-duplicate-string */

const hasContexts = (contexts: Array<string>) => contexts.every(context => window.contexts.includes(context));

import widgetsMgr from 'widgets/widgetsMgr';

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['checkout']),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'checkout.widgets' */ './widgets/checkout/PaymentAccordionCASH_ON_DELIVERY').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './widgets/checkout/PaymentAccordionItemCASH_ON_DELIVERY').then(d => d.default)
        ]).then(deps => {
            const [PaymentAccordionCashOnDelivery, PaymentAccordionItemCashOnDelivery] = deps;

            return {
                listId: 'checkout.cod',
                widgetsDefinition: () => [
                    ['paymentAccordion', PaymentAccordionCashOnDelivery, 'paymentAccordion'],
                    ['paymentAccordionItemCASH_ON_DELIVERY', PaymentAccordionItemCashOnDelivery, 'paymentAccordionItem']
                ]
            };
        })
});
